import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Icon from "../Icon";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var Button = /*#__PURE__*/function (_Component) {
  _inherits(Button, _Component);
  var _super = _createSuper(Button);
  function Button() {
    _classCallCheck(this, Button);
    return _super.apply(this, arguments);
  }
  _createClass(Button, [{
    key: "renderExternalIcon",
    value: function renderExternalIcon() {
      var className = this.props.className;
      var iconScale;
      if (className && className.includes && className.includes('big')) {
        iconScale = 1.15;
      }
      return /*#__PURE__*/React.createElement(Icon, {
        className: cx('icon'),
        name: "externalLink",
        scale: iconScale
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        transformer = _this$props.transformer,
        className = _this$props.className,
        adaptive = _this$props.adaptive,
        children = _this$props.children,
        disabled = _this$props.disabled,
        onClick = _this$props.onClick,
        target = _this$props.target,
        color = _this$props.color,
        href = _this$props.href,
        type = _this$props.type,
        wide = _this$props.wide;
      var Tag = href ? 'a' : 'button';
      var elClassName = cx(className, 'button', color);
      return /*#__PURE__*/React.createElement("div", {
        className: cx({
          wrapper: true,
          wide: wide,
          adaptive: adaptive,
          transformer: transformer
        })
      }, /*#__PURE__*/React.createElement(Tag, {
        className: elClassName,
        disabled: disabled,
        href: href,
        onClick: onClick,
        target: target,
        type: href || type
      }, /*#__PURE__*/React.createElement("span", {
        className: cx('text')
      }, children), href && target === '_blank' && this.renderExternalIcon()));
    }
  }]);
  return Button;
}(Component);
_defineProperty(Button, "defaultProps", {
  /** Children для кнопки по умолчанию */
  children: 'Отправить',
  /** По умолчанию тип кнопки (submit) для отправки данных формы */
  type: 'submit'
});
export { Button as default };
Button.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Параметр для добавления дополнительных классов */
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /** Любой обьект или строка */
  children: PropTypes.any,
  /** Управление документом при переходе по ссылке */
  target: PropTypes.oneOf(['_self', '_blank', '_parent', '_top']),
  /** Тип кнопки — для отправки данных формы на сервер или для очистки формы. */
  type: PropTypes.oneOf(['submit', 'button', 'reset']),
  /** Цвет кнопки */
  color: PropTypes.oneOf(['light', 'yellow']),
  /** Ссылка для перехода по нажатию на кнопку */
  href: PropTypes.string,
  /** Параметр задает размер кнопки, размер зависит от ширины контента */
  transformer: PropTypes.bool,
  /** Параметр задает размер кнопки, размер зависит от ширины контента */
  adaptive: PropTypes.bool,
  /** Блокирует доступ кнопки. Кнопка отображается серой и недоступной для активации */
  disabled: PropTypes.bool,
  /** Callback для события клик */
  onClick: PropTypes.func,
  /** Параметр задает размер кнопки, размер зависит от ширины контента */
  wide: PropTypes.bool
} : {};